import { useQuery } from "@tanstack/react-query"
import type { RelatedCustomersResponse } from "@/shared/api/types/RelatedCustomersResponse"
import { useCmApi } from "@/shared/hooks/useCmApi"

const QUERY_KEY = "relatedCustomers"

export const useGetRelatedCustomers = (customerId?: string) => {
  const cmApi = useCmApi()
  const { data, isLoading, error, isError, refetch } = useQuery<RelatedCustomersResponse | null>({
    queryKey: [QUERY_KEY, customerId],
    queryFn: () => (customerId ? cmApi.getRelatedCustomers(customerId) : null),
    placeholderData: (prev?: RelatedCustomersResponse | null) => prev
  })

  return { data, isLoading, error, isError, refetch }
}
